import { render, staticRenderFns } from "./host.vue?vue&type=template&id=79116a18&scoped=true&"
import script from "./host.vue?vue&type=script&lang=js&"
export * from "./host.vue?vue&type=script&lang=js&"
import style0 from "./host.vue?vue&type=style&index=0&id=79116a18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79116a18",
  null
  
)

export default component.exports